import React from "react";
import { Field } from "../ui/field";
import { Flex, Button, Text, HStack, Spacer, Grid } from "@chakra-ui/react";
import { useState } from "react";
import { RadioGroup, Radio } from "../ui/radio";
import {
  FileUploadList,
  FileUploadRoot,
  FileUploadTrigger,
} from "../ui/file-upload";
import { HiUpload } from "react-icons/hi";
import { useColorModeValue } from "../ui/color-mode";

const UploadFile = ({
  inputTitle,
  fieldId1,
  fieldId2,
  fileName,
  radioName,
  outsideNote,
  insideNote,
  maxFiles = 1,
}) => {
  const [showFileUpload, setShowFileUpload] = useState(false);
  const inputBg = useColorModeValue("#f6f6ff", "#251f35");
  const inputBoxShadow = useColorModeValue(
    "rgba(174, 174, 192, 0.4) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;",
    "rgba(174, 174, 192, 0.1) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.1) -3px -3px 6px 1px inset;"
  );
  const focusShadow = useColorModeValue(
    "inset 6px 6px 10px rgba(174, 174, 192, 0.4), inset -6px -6px 10px #fff",
    "inset 6px 6px 10px rgba(174, 174, 192, 0.1), inset -6px -6px 10px #fff"
  );

  return (
    <>
      <Field id={fieldId1} required>
        <RadioGroup
          name={radioName}
          onChange={(event) => setShowFileUpload(event.target.value === "yes")}
          variant="subtle"
          colorPalette="blue"
        >
          <Grid templateColumns="4fr 1fr" gap={20}>
            <Text fontSize="sm" color="gray.500">
              {inputTitle}
            </Text>
            <HStack gap={4}>
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </HStack>
          </Grid>
        </RadioGroup>
      </Field>

      {/* Housing Loan Statement - Only shown when "Yes" is selected */}
      {showFileUpload && (
        <Field id={fieldId2} required>
          <FileUploadRoot maxFiles={maxFiles}>
            <FileUploadTrigger asChild>
              <Button
                bgColor={inputBg}
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                color="gray.500"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
              >
                <HiUpload /> Upload file
              </Button>
            </FileUploadTrigger>
            <FileUploadList name={fileName} clearable />
          </FileUploadRoot>
          {insideNote}
        </Field>
      )}
      {outsideNote}
      <Spacer h="10" />
    </>
  );
};

export default UploadFile;
